import { render, staticRenderFns } from "./BusinessPlaceEdit.vue?vue&type=template&id=f38ff246&scoped=true&"
import script from "./BusinessPlaceEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessPlaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38ff246",
  null
  
)

export default component.exports